import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppUtils } from 'src/app/helpers/app.utils';
import { isNullOrUndefined } from 'util';
import { PaymentService } from 'src/app/admin/services/payment.service';
import { ActivatedRoute } from '@angular/router';
import { SelectionFilterModel } from 'src/app/admin/models/selection.filter.model';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { TableModel } from 'src/app/models/table.model';
import { ContributorPaymentLogFilterModel } from 'src/app/admin/models/contributor.payment.log.filter.model';
import { PagedContributorPaymentLogDetail } from 'src/app/admin/models/paged.contributor.payment.log.detail';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContributorPaymentLogUpsertComponent } from '../upsert/contributor.payment.log.upsert.component';
import { PageUrls } from 'src/app/helpers/page-urls';

@Component({
    selector: 'app-contributor-payment-log-manage',
    templateUrl: './contributor.payment.log.manage.component.html'
})
export class ContributorPaymentLogManageComponent implements OnInit {
    subscriptions: Subscription[];
    totalRecords: number;
    tableModel: TableModel;
    pagedContributorPaymentLogDetails: PagedContributorPaymentLogDetail = new PagedContributorPaymentLogDetail();
    isModelLoaded = false;
    contributors: Array<SelectListItemModel>;
    contributorSelectionFilter = new SelectionFilterModel<ContributorPaymentLogFilterModel>();
    selectedContributor: SelectListItemModel;
    paymentlogFilterModel = new ContributorPaymentLogFilterModel();
    contributorName: string;
    stripeAccountStatus: number;

    years: Array<number>;
    months: Array<string>;

    get urls() {
        return PageUrls;
    }

    constructor(private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private paymentService: PaymentService,
        private route: ActivatedRoute,
        private modalService: NgbModal) {
            this.paymentlogFilterModel.contributorId = this.route.snapshot.queryParams.id;
            this.contributorName = this.route.snapshot.queryParams.name;
            this.stripeAccountStatus = Number(this.route.snapshot.queryParams.accountStatus);
    }

    ngOnInit() {
        this.years = AppUtils.getYears(2020);

        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];
        this.initSubscribers();
        this.getContributorPaymentLogs();
    }



    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getContributorPaymentLogs());
        this.subscriptions.push(subscription);
    }

    getYearMonthSerialized() {
        if (isNullOrUndefined(this.paymentlogFilterModel.year) || this.paymentlogFilterModel.year === '') {
            this.months.splice(0, this.months.length);
            this.paymentlogFilterModel.month = '';
        } else {
            this.months = AppUtils.getMonths(Number(this.paymentlogFilterModel.year));
        }
        this.getContributorPaymentLogs();
    }

    getContributorPaymentLogs = () => {
        this.ngxSpinnerService.show();
        this.isModelLoaded = false;
        this.ngxSpinnerService.show();
        this.paymentService.GetContributorPaymentLogs(this.paymentlogFilterModel, this.tableModel)
        .subscribe(data => {
            this.pagedContributorPaymentLogDetails = data;
            this.totalRecords = data.totalCount;
            this.pagedContributorPaymentLogDetails.items.forEach(item => {
                item.paymentDate = AppUtils.getFormattedUtcToLocalDateTime(item.paymentDate);
            });
            this.isModelLoaded = true;
            this.ngxSpinnerService.hide();
        }, error => {
            this.ngxSpinnerService.hide();
            this.isModelLoaded = true;
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }

    openPaymentLogUpsert(): void {
        const modal = this.modalService.open(ContributorPaymentLogUpsertComponent);
        modal.componentInstance.contributorId = this.paymentlogFilterModel.contributorId;
        modal.result.then(() => {
            this.getContributorPaymentLogs();
        });
    }
}
